<template>
  <v-app>
    <v-app-bar app color="#827717" dark height="45" style="z-index: 10000;">
      <div class="d-flex align-center">
        <v-img
          alt="Vuetify Logo"
          class="shrink mr-2 mt-n2"
          contain
          :src="require('./assets/logo.png')"
          transition="scale-transition"
          width="60"
        />

        <!-- <v-img
          alt="Vuetify Name"
          class="shrink mt-1 hidden-sm-and-down"
          contain
          min-width="100"
          src="https://cdn.vuetifyjs.com/images/logos/vuetify-name-dark.png"
          width="100"
        /> -->
        <span class="title font-weight-medium"> ボイスクイズ </span>
      </div>

      <v-spacer></v-spacer>

      <!-- <v-btn
        href="https://github.com/vuetifyjs/vuetify/releases/latest"
        target="_blank"
        text
      >
        <span class="mr-2">Latest Release</span>
        <v-icon>mdi-open-in-new</v-icon>
      </v-btn> -->
      <v-btn icon dark @click.stop="dialog = true">
        <v-icon>mdi-information</v-icon>
      </v-btn>
    </v-app-bar>

    <v-main style="height: calc(100vh - 45px);">
      <!-- <v-btn @click="play" /> -->
      <router-view :returnHomeThis="returnHomeThis" v-if="isLoaded" />

      <span v-else>
        <div v-if="isDownloading" class="text-center">
          <v-progress-circular
            rotate="-90"
            :value="progressCircular"
            color="primary"
            class="ma-3"
          ></v-progress-circular>
          <br />{{ progressStr }}
        </div>
      </span>

      <v-dialog v-model="dialog" max-width="500">
        <v-card class="pt-4">
          <v-card-text>
            <strong>検索例</strong><br />
            <br />
            丈槍 由紀の場合<br />
            1.丈槍 由紀 (フルネーム)<br />
            2.ゆき (内部ニックネーム)<br />
            3.yuki (内部英名)<br />
            4.水瀬いのり (声優)<br />
            5.gakkou (内部英作品名)<br />
            <br />
            ジンジャーの場合<br />
            1.ジンジャー<br />
            2.渕上舞<br />
            3.ginger<br />
            4.kirara<br />
            <br />
            乙川 澄の場合<br />
            1.乙川 澄 <br />
            2.sumi <br />
            3.麻倉もも <br />
            4.sakura<br />
            <br />
            うまく検索できない場合、名前をローマ字で検索するといいかもしれません
          </v-card-text>
        </v-card>
      </v-dialog>
    </v-main>
  </v-app>
</template>

<script>
// import HelloWorld from './components/HelloWorld';
import localforage from "localforage";
import axios from "axios";

export default {
  name: "App",

  data: () => ({
    isLoaded: false,

    db: {},
    title_list:[],

    localforage: localforage,
    axios: axios,
    voice_URL_list: {},

    downloadStatus: {
      downloaded: 0,
      max: 0,
    },
    isDownloading: false,

    dialog: false,
  }),

  computed: {
    progressCircular() {
      const dl_status = this.downloadStatus;
      return (dl_status.downloaded / dl_status.max) * 100;
    },
    progressStr() {
      const dl_status = this.downloadStatus;
      return `${dl_status.downloaded} / ${dl_status.max}`;
    },
    returnHomeThis() {
      return this;
    },
  },

  methods: {
    play() {
      let url = this.c;
      let audio = new Audio(url);
      audio.volume = 0.5;
      // audio.addEventListener('ended', function() {
      //   delete audio;
      //   next_music();
      // });
      audio.play();
    },
  },

  async mounted() {
    let vm = this;
    const title_list_prom = this.axios.get(
      "https://database.kirafan.cn/database/TitleList.json"
    );
    const db_prom = this.axios.get(
      "https://database.kirafan.cn/database/NamedList.json"
    );

    this.title_list = (await title_list_prom).data.sort(function (a, b) {
        const a_title = a.m_Order;
        const b_title = b.m_Order;
        if (a_title < b_title) return -1;
        if (a_title > b_title) return 1;
        return 0;
      });
    // console.log(title_list);
    this.db = (await db_prom).data
      .map((chara) => {
      // console.log(chara);
       chara["m_Order"] = this.title_list.find(
          (titleList) => chara["m_TitleType"] === titleList["m_TitleType"]
        )["m_Order"]
        return chara
      })
      .sort(function (a, b) {
        const a_id = a.primaryCharacterID;
        const b_id = b.primaryCharacterID;
        if (a_id < b_id) return -1;
        if (a_id > b_id) return 1;
        return 0;
      })
      .sort(function (a, b) {
        const a_title = a.m_Order;
        const b_title = b.m_Order;
        if (a_title < b_title) return -1;
        if (a_title > b_title) return 1;
        return 0;
      });

    this.downloadStatus.max = this.db.length;

    this.isDownloading = true;

    async function getCacheVoice(id) {
      let voiceData = await vm.localforage.getItem(id);
      // mime 	audio/mpeg
      if (voiceData == null) {
        voiceData = (
          await vm.axios.get(`https://voice-cri.kirafan.cn/Voice_${id}/voice_000_0.mp3`, {
            responseType: "blob",
          })
        ).data;
        localforage.setItem(id, voiceData);
      }
      vm.voice_URL_list[id] = URL.createObjectURL(voiceData);

      vm.downloadStatus.downloaded++;
      // return URL.createObjectURL(voiceData)
    }

    let prom_voiceDL = this.db.map((x) => {
      let id = x["m_ResouceBaseName"];
      return getCacheVoice(id);
    });

    await Promise.all(prom_voiceDL);

    this.isLoaded = true;
  },
};
</script>
